require('./bootstrap');
require('alpinejs');

import InitializeForm from './form.js';
import Navigation from './navigation.js';
import CollapsibleSections from './collapsible-sections.js';
import Messages from './messages.js';
import PLAnalytics from './pl-analytics.js';
import Multilingual from './multilingual.js';
import Connections from './connections.js';
import Modals from './modals.js';
import Resources from './resources.js';
import FormActions from './form-actions.js';

(function ($) {
    $(document).ready(function () {
        new InitializeForm().initialize();
        new Navigation().initialize();
        new CollapsibleSections().initialize();
        new Messages().initialize();
        new PLAnalytics().initialize();
        new Multilingual().initialize();
        new Connections().initialize();
        new Modals().initialize();
        new Resources().initialize();
        new FormActions().initialize();
    });
})(jQuery);

// callback function, MUST be in the global scope
function setCaptchaResponse() {
    window.livewire.emit('set:captcha', grecaptcha.getResponse());
}
window.setCaptchaResponse = setCaptchaResponse;
